import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

export const AccessPortalWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  animation: ${fadeIn} 0.3s ease-in;
`;

export const AccessPortalInternal = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  max-width: 500px;
  width: 100%;
  text-align: center;
`;

export const AccessPortalTitle = styled.h1`
  font-size: ${(props) => props.theme.fontSizeTitle};
  color: ${(props) => props.theme.titleColor};
  margin: 0;

  @media only screen and (max-width: ${(props) => props.theme.breakpointSm}) {
    font-size: ${(props) => props.theme.fontSizeMobileTitle};
  }
`;

export const AccessPortalParagraph = styled.p`
  font-size: ${(props) => props.theme.fontSizeMd};
  color: ${(props) => props.theme.secondaryColor};
  line-height: 1.7;
  margin: 0;
`;

export const AccessPortalErrorText = styled.p`
  font-size: ${(props) => props.theme.fontSizeBase};
  color: ${(props) => props.theme.warningColor};
  margin: 0;
`;

export const AccessPortalButton = styled.button`
  background-color: ${(props) => props.theme.buttonBg};
  color: ${(props) => props.theme.white};
  border: none;
  padding: 0.75rem 2.5rem;
  cursor: pointer;
  font-size: ${(props) => props.theme.fontSizeLg};
  font-weight: 600;
  transition: background-color 0.125s ease-in;

  &:hover {
    background-color: ${(props) => props.theme.buttonBgHover};
  }

  &:disabled {
    color: ${(props) => props.theme.disabledColor};
    background-color: ${(props) => props.theme.disabledBg};
    cursor: not-allowed;
  }
`;

export const AccessPortalLogo = styled.img`
  height: 6rem;
  width: auto;
  margin-bottom: 1rem;

  &:hover {
    cursor: pointer;
  }

  @media only screen and (max-width: ${(props) => props.theme.breakpointSm}) {
    height: 3.5rem;
  }
`;
